export const TOOLS = [
  {
    id: "mensualite-credit",
    title: "Calcul mensualité crédit",
    desc: "Mensualité, coût total, intérêts + tableau d’amortissement.",
    path: "/calcul-mensualite-credit",
    category: "Acheter",
    tags: ["crédit", "mensualité", "amortissement"],
    popular: true,
    status: "ready", // ready | soon
  },
  {
    id: "capacite-emprunt",
    title: "Calcul capacité d’emprunt",
    desc: "Montant empruntable selon revenus, charges et endettement.",
    path: "/calcul-capacite-emprunt",
    category: "Acheter",
    tags: ["emprunt", "revenus", "endettement"],
    popular: true,
    status: "ready",
  },
  {
    id: "frais-notaire",
    title: "Estimation frais de notaire",
    desc: "Estimation simple ancien/neuf + fourchette.",
    path: "/estimation-frais-notaire",
    category: "Acheter",
    tags: ["notaire", "frais", "achat"],
    popular: true,
    status: "ready",
  },
  {
    id: "rentabilite-locative",
    title: "Rentabilité locative",
    desc: "Rendement brut/net + cashflow (simple).",
    path: "/calcul-rentabilite-locative",
    category: "Investir",
    tags: ["rentabilité", "investissement", "cashflow"],
    popular: true,
    status: "ready",
  },
  {
    id: "plus-value",
    title: "Calcul plus-value immobilière",
    desc: "Estimation simplifiée selon durée de détention.",
    path: "/calcul-plus-value-immobiliere",
    category: "Vendre",
    tags: ["vente", "plus-value"],
    popular: false,
    status: "ready",
  },
  {
    id: "attestation-hebergement",
    title: "Attestation d’hébergement (PDF)",
    desc: "Génère une attestation prête à imprimer.",
    path: "/generateur-attestation-hebergement",
    category: "Documents",
    tags: ["attestation", "pdf", "hébergement"],
    popular: true,
    status: "ready",
  },
];

export const CATEGORIES = [
  "Tous",
  "Acheter",
  "Investir",
  "Vendre",
  "Documents",
];
